// src/utils/apiCache.js

const PREFIX = 'apiCache:';

/**
 * Get a cached value if it exists and hasn't expired.
 * @param {string} key
 * @returns {{ data: any, ts: number } | null}
 */
export function getCached(key) {
  try {
    const raw = sessionStorage.getItem(PREFIX + key);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed.ts !== 'number') return null;
    if (Date.now() - parsed.ts > parsed.ttl) {
      sessionStorage.removeItem(PREFIX + key);
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

/**
 * Store a value with a TTL (ms).
 */
export function setCached(key, data, ttl = 60_000) {
  try {
    sessionStorage.setItem(
      PREFIX + key,
      JSON.stringify({ data, ts: Date.now(), ttl })
    );
  } catch {
    /* quota exceeded — ignore */
  }
}

/**
 * Invalidate a specific key.
 */
export function invalidate(key) {
  try {
    sessionStorage.removeItem(PREFIX + key);
  } catch {
    /* ignore */
  }
}

/**
 * Invalidate every key that starts with a prefix.
 * e.g. invalidatePrefix('courseAdmin:')
 */
export function invalidatePrefix(prefix) {
  try {
    const full = PREFIX + prefix;
    Object.keys(sessionStorage)
      .filter((k) => k.startsWith(full))
      .forEach((k) => sessionStorage.removeItem(k));
  } catch {
    /* ignore */
  }
}

/**
 * Clear the entire api cache (call on logout).
 */
export function clearAll() {
  try {
    Object.keys(sessionStorage)
      .filter((k) => k.startsWith(PREFIX))
      .forEach((k) => sessionStorage.removeItem(k));
  } catch {
    /* ignore */
  }
}